"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIsIntegrationRequire = exports.getIsIntegrationNeverPrompt = exports.getSettings = exports.getIsFulfilled = exports.getIsPending = exports.getIsIdle = exports.getStatus = exports.getSettingsState = void 0;

var _ramda = require("ramda");

var _utils = require("@alycecom/utils");

var _settings = require("./settings.types");

var getSettingsState = function getSettingsState(state) {
  return state.modules.teams.settings;
};

exports.getSettingsState = getSettingsState;
var getStatus = (0, _ramda.pipe)(getSettingsState, (0, _ramda.prop)('status'));
exports.getStatus = getStatus;
var getIsIdle = (0, _ramda.pipe)(getStatus, (0, _ramda.equals)(_utils.StateStatus.Idle));
exports.getIsIdle = getIsIdle;
var getIsPending = (0, _ramda.pipe)(getStatus, (0, _ramda.equals)(_utils.StateStatus.Pending));
exports.getIsPending = getIsPending;
var getIsFulfilled = (0, _ramda.pipe)(getStatus, (0, _ramda.equals)(_utils.StateStatus.Fulfilled));
exports.getIsFulfilled = getIsFulfilled;
var getSettings = (0, _ramda.pipe)(getSettingsState, (0, _ramda.prop)('data'));
exports.getSettings = getSettings;
var getIsIntegrationNeverPrompt = (0, _ramda.pipe)(getSettings, function (settings) {
  return (settings === null || settings === void 0 ? void 0 : settings.requireEmailIntegration) === _settings.RequireEmailIntegrationOption.NotShow;
});
exports.getIsIntegrationNeverPrompt = getIsIntegrationNeverPrompt;
var getIsIntegrationRequire = (0, _ramda.pipe)(getSettings, function (settings) {
  return (settings === null || settings === void 0 ? void 0 : settings.requireEmailIntegration) === _settings.RequireEmailIntegrationOption.Required;
});
exports.getIsIntegrationRequire = getIsIntegrationRequire;